import { render, staticRenderFns } from "./Seccion_comprobante.vue?vue&type=template&id=0211d773&lang=pug&"
import script from "./Seccion_comprobante.vue?vue&type=script&lang=js&"
export * from "./Seccion_comprobante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports